import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { languageswitchConstants } from '../constants';
import { SocialMediaListRender } from './SocialMediaListRender';


export const SocialMediaList = () => {
    const dispatch = useDispatch();
    const s = useSelector(state => state.socialmedia.socialmediaList);
    const [socialmediaList, setSocialmedialList] = useState(s);
    const loading = useSelector(state => state.socialmedia.loading);
    const e = useSelector(state => state.socialmedia.error);
    const [error, setError] = useState(e);
    const d = useSelector(state => state.socialmedia.done);
    const [done, setDone] = useState(d);
    var dataLimitPerPage = 15;

    const lang = useSelector(state => state.languageswitch);
    if (lang === languageswitchConstants.ENGLISH_NR) {
        return <SocialMediaListRender
            stateList={s}
            socialmediaList={socialmediaList}
            setSocialmedialList={setSocialmedialList}
            loading={loading}
            errorState={e}
            error={error}
            setError={setError}
            doneState={d}
            done={done}
            setDone={setDone}
            dataLimitPerPage={dataLimitPerPage}
        />
    }
}

